import { VUE_APP_GCN_SERVICES } from '@/constants';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/publico/origemnormaleg`;

class OrigemNormaLegService {
  public async baixarOrigemNorma(
    hashCdFonte: string,
    hashCdOrigemNorma: string
  ) {
    const url = `${BASE_URL}/arquivo/${hashCdFonte}/${hashCdOrigemNorma}`;
    window.open(url, '_blank');
  }
}

export default new OrigemNormaLegService();
